// extracted by mini-css-extract-plugin
export var checkbox = "Checkbox-module--checkbox--sDdeU";
export var disabled = "Checkbox-module--disabled--3m2U6";
export var unselected = "Checkbox-module--unselected--2fQAp";